module.exports = __webpack_public_path__ + "media/images/lb/019-14e607c89fcb99258433e76f875f5550.svg";